"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireWildcard(require("react"));
var _useOnclickoutside = _interopRequireDefault(require("use-onclickoutside"));
var _dropdownWithButton = require("./dropdownWithButton.style");
var _Icon = _interopRequireDefault(require("../../Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// import { Components as DropdownFilterComponents } from './filterBar.style';

function DropdownFilter(_ref) {
  let {
    id,
    options,
    selectedFilter,
    onChange,
    onDelete
  } = _ref;
  const [query, setQuery] = (0, _react.useState)(selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.filter_title);
  const [isOptionsOpen, setIsOptionsOpen] = (0, _react.useState)(false);
  const [computedOptions, setComputedOptions] = (0, _react.useState)(options);
  (0, _react.useEffect)(() => {
    setComputedOptions(query ? options.filter(option => {
      var _a;
      return (_a = option.filter_title) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().match(query.toLowerCase());
    }) : options);
  }, [query]);
  (0, _react.useEffect)(() => {
    if (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.filter_title) {
      setQuery(selectedFilter.filter_title);
    }
  }, [selectedFilter]);
  const dropdownMenuRef = _react["default"].useRef(null);
  const onClickShowOptions = () => {
    setIsOptionsOpen(true);
    setQuery('');
  };
  const onClickOutsideHideOptions = () => {
    setIsOptionsOpen(false);
    setQuery(selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.filter_title);
  };
  const filterFunction = event => {
    const element = event.target;
    setQuery(element.value);
    setIsOptionsOpen(true);
  };
  const onItemDelete = deleteSelectedItem => {
    onChange(deleteSelectedItem);
    onDelete(deleteSelectedItem === null || deleteSelectedItem === void 0 ? void 0 : deleteSelectedItem.filter_title);
  };
  const onSelect = selectedItem => {
    onChange(selectedItem);
    onClickOutsideHideOptions();
  };
  (0, _useOnclickoutside["default"])(dropdownMenuRef, onClickOutsideHideOptions);
  return (0, _jsxRuntime.jsxs)(_dropdownWithButton.Components.DropdownWrapper, (0, _extends2["default"])({
    id: id,
    onClick: onClickShowOptions,
    ref: dropdownMenuRef
  }, {
    children: [(0, _jsxRuntime.jsxs)(_dropdownWithButton.Components.DropdownContainer, {
      children: [(0, _jsxRuntime.jsx)(_dropdownWithButton.Components.DropdownInput, {
        id: "searchableSelectWithButtonInOptions-input",
        type: "text",
        placeholder: "Select saved filters",
        value: query,
        onChange: event => {
          filterFunction(event);
        }
      }), (0, _jsxRuntime.jsx)(_Icon["default"], {
        name: isOptionsOpen ? 'chevron-up' : 'chevron-down'
      })]
    }), isOptionsOpen && (0, _jsxRuntime.jsx)(_dropdownWithButton.Components.DropdownOptionsContainer, {
      children: computedOptions.map((item, index) => (0, _jsxRuntime.jsx)(_dropdownWithButton.Components.DropdownOptions, (0, _extends2["default"])({
        onClick: e => {
          e.stopPropagation();
          onSelect(item);
        }
      }, {
        children: (0, _jsxRuntime.jsxs)(_dropdownWithButton.Components.DropdownOption, {
          children: [(0, _jsxRuntime.jsx)(_dropdownWithButton.Components.DropdownOptionContent, {
            children: item.filter_title
          }), (0, _jsxRuntime.jsx)(_Icon["default"], {
            name: "trash",
            size: "20",
            onClick: () => onItemDelete(item)
          })]
        })
      }), index))
    }), isOptionsOpen && computedOptions.length === 0 && (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
      className: "dropdown__with__button__options"
    }, {
      children: "No saved filters found"
    }))]
  }));
}
var _default = exports["default"] = DropdownFilter;